module.exports = __webpack_public_path__ + "static/img/logo_takima_horizontal_inverted-1.0226c272.png";